<script lang="ts">
  import { fly } from "svelte/transition";
  import Loader from "./Loader.svelte";

  type Variants = "primary" | "secondary" | "ghost";
  interface Props {
    variant?: Variants;
    type?: "button" | "submit";
    disabled?: boolean;
    href?: any;
    animate?: boolean;
    target?: string;
    loading?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
    onClick?: () => void;
  }

  let {
    variant = "primary",
    type = "button",
    disabled = false,
    href = undefined,
    animate = true,
    target = "",
    loading = false,
    class: className,
    children,
    onClick,
  }: Props = $props();
</script>

{#if href}
  <a
    in:fly={{ x: 500, duration: animate ? 600 : 0 }}
    {target}
    {href}
    data-variant={variant}
    class="{className} btn"
  >
    {@render children?.()}
  </a>
{:else}
  <button
    in:fly={{ x: 500, duration: animate ? 600 : 0 }}
    {type}
    {disabled}
    onclick={onClick}
    data-variant={variant}
    class="{loading ? 'disabled pointer-events-none opacity-80' : ''} {className} btn"
  >
    {#if loading}
      <Loader variant={"white"} size={"xs"} />
    {:else}
      {@render children?.()}
    {/if}
  </button>
{/if}
